import { Card, CardContent, Box, Divider } from "@mui/material";
import styles from "./StockCard.module.css";
import { formatNum } from "../../../oscar-pos-core/constants";
import { ParagraphText, UBButton } from "../../../Libraries";
import RangePicker from "../RangePicker";
import { useContext, useMemo, useState } from "react";
import { CalendarIconNew } from "../../../assets/icons/icon";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { dateFormatInNumberWithSpace } from "../../../utils";
import { DEFAULT_DATE_FILTERS_REPORTS } from "../../../constants";

const StockCard = ({
  title = "Item details",
  titleAmount,
  subHeading,
  firstHeading,
  secondHeading,
  thirdHeading,
  showRangePicker = false,
  selectedDate = null,
  handleFilterDate = () => {},
}) => {
  const [I18n] = useContext(LanguageContext);
  const [isOpenPicker, setIsOpenPicker] = useState(false);

  const FILTER_DISPLAY_LABELS = {
    Today: I18n.today || "Today",
    "7 days": I18n.weekly || "Weekly",
    "30 days": I18n.monthly || "Monthly",
    "365 days": I18n.yearly || "Yearly",
  };

  const dateLabel = useMemo(() => {
    if (!selectedDate?.start) return I18n.select_date;
    if (selectedDate?.label)
      return FILTER_DISPLAY_LABELS[selectedDate.label] || selectedDate.label;
    const start = dateFormatInNumberWithSpace(selectedDate.start);
    if (!selectedDate.end) return start;
    return `${start} - ${dateFormatInNumberWithSpace(selectedDate.end)}`;
  }, [selectedDate, I18n]);

  return (
    <Card className={styles.card}>
      <CardContent className={styles.cardContent}>
        {/* Title */}
        <Box className={styles.titleWrapper}>
          <ParagraphText className={styles.title}>{title}</ParagraphText>

          {showRangePicker ? (
            <Box className={styles.exportWrap}>
              <UBButton
                id="stock_card_add_btn"
                title={dateLabel}
                onClick={() => {
                  triggerLogEvent(analytics, "sb_stock_card_click", { title });
                  setIsOpenPicker(!isOpenPicker);
                }}
                iconComponent={<CalendarIconNew width="12px" height="12px" />}
                className={styles.exportButton}
              />

              <RangePicker
                onFilterDate={(start, end, label) => {
                  handleFilterDate(start, end, label);
                  setIsOpenPicker(false);
                }}
                onClearBtn={() => handleFilterDate(null, null)}
                isOpen={isOpenPicker}
                setIsOpen={setIsOpenPicker}
                showDirectPicker={true}
                rangeValue={
                  selectedDate?.start && selectedDate?.end
                    ? [selectedDate.start, selectedDate.end]
                    : []
                }
                className={styles.rangePickerWrapper}
                noClearBtn={false}
                dateFilters={DEFAULT_DATE_FILTERS_REPORTS}
              />
            </Box>
          ) : null}
        </Box>

        {/* Selling Price */}
        <Box className={styles.sellingPriceWrapper}>
          <ParagraphText
            className={`${styles.sellingPrice} fontSize20 fontWeight500 truncate`}
          >
            Rs. {titleAmount ? formatNum(titleAmount) : 0}
          </ParagraphText>

          <ParagraphText className={styles.label}>{subHeading}</ParagraphText>
        </Box>

        <Divider className={styles.divider} />

        {/* Cost Price */}
        <Box className={styles.row}>
          <ParagraphText className={styles.label}>
            {firstHeading?.title}
          </ParagraphText>
          <ParagraphText className={styles.value}>
            {firstHeading?.value ? firstHeading.value : 0}
          </ParagraphText>
        </Box>

        {/* Available Stock */}
        <Box className={styles.row}>
          <ParagraphText className={styles.label}>
            {secondHeading?.title}
          </ParagraphText>
          <ParagraphText className={styles.value}>
            {secondHeading?.value ? secondHeading.value : 0}
          </ParagraphText>
        </Box>

        {/* Stock Value */}
        <Box className={styles.row}>
          <ParagraphText className={styles.label}>
            {thirdHeading?.title}
          </ParagraphText>
          <ParagraphText className={styles.value}>
            {thirdHeading?.value ? thirdHeading.value : 0}
          </ParagraphText>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StockCard;
